import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Versions/Versions";
import * as React from 'react';
export default {
  Content,
  React
};